import { GenericStatus } from "./props";
import { faCheckCircle, faXmarkCircle, faClock } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const VesselRequisitionStatus: GenericStatus[] = [
    {key: "requested", text: "Requested", tagVariant: 'primary'},
    {key: "approved", text: "Approved", tagVariant: 'active'},
    {key: "completed", text: "Completed", tagVariant: 'success'},
    {key: "rejected", text: "Rejected", tagVariant: 'error'}
]

export default VesselRequisitionStatus;